<template>
  <div>
    <div v-html="info.proof" class="chemistry-table" id="chemistry-table"></div>
  </div>
</template>

<script>
export default {
    props:['info'],
    methods:{
        
        locateRowByTDContent(tableId, tdContent,color) {
            let table = document.getElementById(tableId);
            let rows = table.getElementsByTagName('tr');
            
            for (var i = 0; i < rows.length; i++) {
                var cells = rows[i].getElementsByTagName('td');
                for (var j = 0; j < cells.length; j++) {
                if (cells[j].textContent === tdContent) {
                    // 找到匹配的td，执行操作
                    // 例如：
                    rows[i].style.backgroundColor = color; // 高亮显示行
                    return rows[i]; // 返回行元素
                }
                }
            }
            
            return null; // 如果没有找到，返回null
        }
 
    },
    watch:{
        info:{
            immediate:true,
            handler(val){
                if(val.proof){
                    console.log(123)
                    
                }
            }
        }
    },
    updated(){
        this.locateRowByTDContent('chemistry-table','批号:','#00FF00')
                    this.locateRowByTDContent('chemistry-table','熔炼号:','#FF0000')
    },
    mounted(){
       
        
    }
}
</script>

<style scoped>
    /deep/ .chemistry-table table{
        border:solid 1px #000;
        border-collapse: collapse;

    }
    /deep/ .chemistry-table td{
        margin:0;padding:0;border-right: solid 1px #000;border-bottom: solid 1px #000;font-size: 24px;
    }
</style>


// WEBPACK FOOTER //
// src/components/man2/zs.vue